module.exports = __webpack_public_path__ + "img/Boxarrowright.cd1b017c.png";